import React from 'react';
import './Partner.css';
const Partner = () => {
    return (
        <div className='mb-24 bg-white p-20'>
            <h1 className=' mt-5 text-2xl px-4 mb-16 text-center font-semibold mx-auto text-black'>Join 1000s of brands that trust our organization to achieve their goals</h1>
            <img className='partners-img' src='https://i.ibb.co/GvGhhdH/R.jpg' alt='' />
        </div>
    );
};

export default Partner;